var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.isLoading,"spinner-variant":"primary","variant":"light","opacity":"0.5","blur":"1px","rounded":"sm"}},[_c('apex-chart',{attrs:{"type":"bar","height":350,"options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }